import { Component, h, Host, Prop, Watch, Element } from '@stencil/core';
import { isMagnoliaEditingMode } from '../../helper';
import { observereGroupedElementsToReadjust } from '../../global/utility/observe-grouped-elements-to-readjust/observe-grouped-elements-to-readjust';
import { readjustGroupedElements } from '../../global/utility/readjust-grouped-elements/readjust-grouped-elements';

interface UiCmsFlipcardGroupBody {
  columns: 2 | 3;
}

@Component({
  tag: 'ui-cms-flipcard-group',
  styleUrls: { default: 'ui-cms-flipcard-group.scss', editing: 'ui-cms-flipcard-group.magnolia.scss' },
})
export class UiCmsFlipcardGroup {
  @Element() el: HTMLElement;

  @Prop({ mutable: true, attribute: 'body' }) utilityBody: string;

  @Prop({ mutable: true }) body: UiCmsFlipcardGroupBody = {} as any;

  cards: HTMLUiCmsFlipcardElement[];

  @Watch('utilityBody')
  utilityBodyChangeHandler(newValue) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.utilityBodyChangeHandler(this.utilityBody);
  }

  componentDidLoad() {
    this.cards = [].slice.call(this.el.querySelectorAll('ui-cms-flipcard'));
    this.setRatio();
    if (isMagnoliaEditingMode()) {
      const mglBars = [].slice.call(this.el.querySelectorAll('.mgnlEditorBar.component'));
      readjustGroupedElements(mglBars, this.cards);
      observereGroupedElementsToReadjust(this.el, this.cards);
    }
  }

  private setRatio() {
    this.cards.forEach((card) => {
      if (this.body.columns === 2) {
        card.setAttribute('ratio', '16/9');
      } else {
        card.setAttribute('ratio', '4/3');
      }
    });
  }

  render() {
    return (
      <Host columns={this.body.columns}>
        <div class="flipcard-group">
          <slot />
        </div>
      </Host>
    );
  }
}
